/// <reference path="typings/ELearning.d.ts" />

import '../less/all.less';
import Form from './modules/Form'
import PolyfillLoader from './PolyfillLoader';
import ModuleLoader from './ModuleLoader';
import LazySliders from './modules/LazySliders';
import AjaxLoader from './AjaxLoader';
import Layer from './modules/Layer';
import URLChecker from './URLChecker';
import AutoComplete from './modules/AutoCompleteApi';
import YouTubeManager from './YouTubeManager';


window.Beiersdorf = {};

class Application {
    private selector: string;
    moduleLoader: ModuleLoader;
    AutoComplete: AutoComplete;
    layer: Layer;
    metaTag;
    lazySlider: LazySliders;
    urlChecker: URLChecker;
    youTubeManager: YouTubeManager;



    constructor({ selector }: ApplicationOptions) {
        this.selector = selector;
        this.initPolyfills().then(() => this.init());
        this.checkViewport();
        this.initYouTubeManager();


        window.addEventListener("resize", () => this.checkViewport());
    }

    private init(): void {
        this.initModules()
            .initLayer()
            .initAlpacaForm()
            .initURLChecker()
            .initOverlayButton()
            .initLazySlider();
        this.initAutoComplete();
    }

    private initAutoComplete(): Application {
        this.AutoComplete = new AutoComplete();
        return this;
    }

    private initModules(): Application {
        this.moduleLoader = new ModuleLoader(this.selector);
        return this;
    }

    private initPolyfills() {
        return new PolyfillLoader().init();
    }

    private initLazySlider() {
        this.lazySlider = new LazySliders();
    }

    private initLayer(): Application {
        this.layer = new Layer(true);
        return this;
    }

    private initAlpacaForm(): Application {
        document.addEventListener('alpaca:forms:ready', (event) => {

            console.log('alpaca ready');
            const fromNode = (<CustomEvent>event).detail.formNode;
            new Form(fromNode);

        });
        return this;
    }

    private initURLChecker(): Application {
        new URLChecker();
        return this;
    }

    private initOverlayButton(): Application {
        Array.from(document.querySelectorAll('[data-show-login-overlay]')).filter((node: HTMLElement) => !node.dataset.moduleInitialized).forEach((element: HTMLElement) => {
            element.addEventListener('click', (e) => window.Beiersdorf.layerButtonOverlay(e))
        });

        return this;
    }

    private checkViewport() {
        if (window.outerWidth >= 768 && window.outerWidth < 1440) {
            this.tabletMode();
        } else {
            this.generalViewport();
        }
    }

    private tabletMode() {
        let scaleFactor = window.outerWidth / 1440;
        if (scaleFactor > 1.0) {
            // Shouldn't happen, just keep it to be safe.
            scaleFactor = 1.0;
        }

        this.metaTag = document.querySelector("meta[name=viewport]");
        if (!this.metaTag) {
            this.metaTag = document.createElement('meta');
            this.metaTag.name = "viewport";
        }
        this.metaTag.content = `width=1440, initial-scale=${scaleFactor}`;
        document.getElementsByTagName('head')[0].appendChild(this.metaTag);
    }

    private generalViewport() {
        this.metaTag = document.querySelector("meta[name=viewport]");
        if (!this.metaTag) {
            this.metaTag = document.createElement('meta');
            this.metaTag.name = "viewport";
        }
        this.metaTag.content = "width=device-width, initial-scale=1";
        document.getElementsByTagName('head')[0].appendChild(this.metaTag);
    }

    private initYouTubeManager(): Application {
        this.youTubeManager = new YouTubeManager();
        return this;
    }
}

document.addEventListener("DOMContentLoaded", function () {
    // this function runs when the DOM is ready, i.e. when the document has been parsed
    window.Beiersdorf.getLayer = function () {
        return app.layer;
    };

    window.Beiersdorf.initModules = function (): void {
        app.moduleLoader.initModules();
    }

    window.Beiersdorf.openLayer = function (url, layerClass = '') {
        let ajaxLoader = new AjaxLoader((responseText) => onSuccess(responseText), null);
        ajaxLoader.requestUrl(url);



        function onSuccess(responseText) {
            window.Beiersdorf.openLayerContent(responseText, layerClass);
        }
    };

    window.Beiersdorf.openLayerContent = function (responseText, layerClass) {

        let layer: Layer = window.Beiersdorf.getLayer();
        let responseTextWrapper = document.createElement('div');
        responseTextWrapper.innerHTML = responseText;

        var layerContent = `
        <div class="layer-overlay__content">${responseTextWrapper.innerHTML}</div>`;

        layer.open(layerContent, layerClass, { callbacks: { beforeOpen: () => { window.Beiersdorf.initModules() } } });
    };

    window.Beiersdorf.layerButtonOverlay = function (event) {

        this.ajaxField = document.querySelector(".login-overlay[data-ajax-url]");
        if (this.ajaxField) {
            event.preventDefault();
            const loginurl = this.ajaxField.getAttribute('data-ajax-url');
            window.Beiersdorf.openLayer(loginurl, 'login-overlay');
        }
    }

    const app = new Application({
        selector: '[data-module]'
    });
});
